<script setup lang="ts">
import { ElTooltip } from 'element-plus'
import { PencilIcon, LocationDotIcon, CameraIcon } from 'Common/components/elements/icons/Icons'
import { ViewModes } from 'Modules/types/pages/imageReview/enums'
import { showImageComparison } from '@/featureFlags'

interface PropTypes {
  mode: ViewModes
  setMode: (newMode: ViewModes) => void
}

const props = defineProps<PropTypes>()

const getIconWrapperClass = (mode: ViewModes) => {
  if (props.mode === mode) {
    return 'bg-gray-800 text-orange-600'
  }
  return 'bg-white text-black hover:bg-gray-700 hover:text-white'
}
</script>

<template>
  <div id="image-review-toolbar" class="bg-stone-200 h-full w-full flex flex-col items-center justify-start">
    <el-tooltip placement="right" content="Image Annotator">
      <span
        :class="`px-2 w-full py-2 flex items-center justify-center hover:cursor-pointer ${getIconWrapperClass(
          ViewModes.Annotator
        )}`"
        @click="() => props.setMode(ViewModes.Annotator)"
      >
        <PencilIcon />
      </span>
    </el-tooltip>
    <el-tooltip placement="right" content="Waypoint Visualizer">
      <span
        :class="`px-2 w-full py-2 flex items-center justify-center hover:cursor-pointer ${getIconWrapperClass(
          ViewModes.Visualizer
        )}`"
        @click="() => props.setMode(ViewModes.Visualizer)"
      >
        <LocationDotIcon />
      </span>
    </el-tooltip>
    <el-tooltip v-if="showImageComparison" placement="right" content="Image History">
      <span
        :class="`px-2 w-full py-2 flex items-center justify-center hover:cursor-pointer ${getIconWrapperClass(
          ViewModes.History
        )}`"
        @click="() => props.setMode(ViewModes.History)"
      >
        <CameraIcon />
      </span>
    </el-tooltip>
  </div>
</template>
